import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _templateObject, _templateObject2;

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled, { css } from 'styled-components';
import { getPropsBlocker, makePropList } from '../../../../utils';
import { getComponentOverride } from '../../../../system/mixins/getComponentOverride';
var propertyList = makePropList(['isActive']);

var HeaderNavigationLinkRootWrapper = function HeaderNavigationLinkRootWrapper(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return children(_objectSpread({}, restProps));
};

var navigationLinkRootStyle = function navigationLinkRootStyle(_ref2) {
  var isActive = _ref2.isActive,
      HeaderNavigationLink = _ref2.theme.componentOverrides.HeaderNavigationLink;
  var result = HeaderNavigationLink.Root.base;

  if (isActive) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            position: relative;\n            &:before {\n                content: '';\n                position: absolute;\n                bottom: 0;\n                left: 0;\n                right: 0;\n                height: 2px;\n            }\n            ", "\n        "])), result, HeaderNavigationLink.Root.active);
  }

  return result;
};

export var HeaderNavigationLinkRoot = styled(HeaderNavigationLinkRootWrapper).withConfig(getPropsBlocker(propertyList, false))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    border: none;\n    box-sizing: border-box;\n    display: inline-flex;\n\n    text-decoration: none;\n    &:hover,\n    &:visited,\n    &:active,\n    &:focus {\n        text-decoration: none;\n    }\n\n    ", ";\n    ", ";\n    background-color: transparent;\n"])), navigationLinkRootStyle, getComponentOverride('HeaderNavigationLink'));